import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { contentSpacingStyles, titleSpacingStyles } from "@tKgpco/theme/mixins";
import breakpointValuesMediaQueries from "@tKgpco/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

export default {
    fontFamilyImportUrl:
        "https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,700,700i|Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i&display=swap",
    body: {
        fontFamily: TYPOGRAPHY.fontFamily.base,
        lineHeight: TYPOGRAPHY.lineHeight.base,
        size: TYPOGRAPHY.size.base,
        weight: TYPOGRAPHY.weight.base,
    },
    legend: {
        size: TYPOGRAPHY.size.tiny,
        weight: TYPOGRAPHY.weight.bold,
        color: COLORS.text.base,
        transform: "uppercase",
    },
    p: {
        size: "inherit",
        weight: "inherit",
        css: css`
            ${contentSpacingStyles()}
        `,
    },
    h1: {
        size: 29,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, 31, 37, null, 48], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h2: {
        size: 22,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.25,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 22, null, 22], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h3: {
        size: 16,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.3,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 16, null, 16], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h4: {
        size: 14,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.3,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 14, null, 14], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h5: {
        size: 12,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.3,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 12, null, 12], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h6: {
        size: 14,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.3,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 12, null, 12], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerPrimary: {
        transform: "none",
        size: 29,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, 31, 37, null, 70], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerSecondary: {
        transform: "none",
        size: 22,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, null, null, null], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerTertiary: {
        transform: "none",
        size: 20,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, null, null, 30], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
};
